import { CommonModule } from '@angular/common';
import { Pipe, NgModule } from '@angular/core';

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MemoizePipe = class MemoizePipe {
    transform(fn, ...args) {
        return fn(...args);
    }
};
MemoizePipe = __decorate([
    Pipe({
        name: 'wizMemoize',
        pure: true,
    })
], MemoizePipe);

var __decorate$1 = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let MemoizePipeModule = class MemoizePipeModule {
};
MemoizePipeModule = __decorate$1([
    NgModule({
        imports: [CommonModule],
        declarations: [MemoizePipe],
        exports: [MemoizePipe],
    })
], MemoizePipeModule);

export { MemoizePipe, MemoizePipeModule };
//# sourceMappingURL=wizbii-angular-utils.js.map
